/*
 * @Descripttion: 提示信息UI通用组件(蓝色实心感叹号，背景淡蓝色)
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React from 'react';
import styles from './index.module.scss';

const Tips = (props) => {
  const { content } = props;
  return (
    <div className={styles.notice}>
      <div style={{ width: '16px' }}>
        <span
          className="iconfont icon-icon4-38"
          style={{ fontSize: '16px', color: 'rgb(51, 153, 255)' }}
        />
      </div>
      <div className={styles.font}>{content}</div>
    </div>
  );
};

export default Tips;
